<div class="checkbox-list">
  @for(item of items; track item.name; let i = $index){
  <button
    [id]="id + '-' + item.name"
    class="checkbox-item"
    (click)="onClickButton($event, item.name, i)"
  >
    <input
      [id]="id + '-' + i"
      type="checkbox"
      (click)="onClickCheckbox($event, item.name)"
      [checked]="item.value"
      [tabIndex]="-1"
    />
    <sl-typography
      [text]="item.name"
      variant="body-10"
      weight="regular"
    ></sl-typography>
  </button>
  }
</div>
